{
const STORAGE_KEY = 'price-mode';
const DEFAULT_MODE = 'b2b';
const MODES = ['b2b', 'rrp'];
const BODY_CLASSES = {
  rrp: 'price-mode-rrp',
  b2b: 'price-mode-b2b',
};

class PriceModeSwitcher extends HTMLElement {
  getStoredMode() {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_MODE;
    } catch (error) {
      return DEFAULT_MODE;
    }
  }

  setStoredMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      // Ignore storage failures.
    }
  }

  applyBodyMode(mode) {
    document.body.classList.remove(BODY_CLASSES.rrp, BODY_CLASSES.b2b);
    document.body.classList.add(BODY_CLASSES[mode]);
    document.body.dataset.priceMode = mode;
    document.documentElement.dataset.priceMode = mode;
  }

  updateMode(mode, persist = true) {
    console.log("mode", mode);
    
    if (persist) {
      this.setStoredMode(mode);
    }

    this.applyBodyMode(mode);

    this.sync(mode);
  }

  connectedCallback() {
    this.updateMode(this.getStoredMode(), false);

    this.onClick = this.onClick.bind(this);
    this.onModeChange = this.onModeChange.bind(this);

    this.addEventListener('click', this.onClick);

    this.sync(this.getStoredMode());
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-price-mode-option]');

    if (!(button instanceof HTMLElement) || !this.contains(button)) return;

    const mode = button.getAttribute('data-price-mode-option');
    this.updateMode(mode, true);

    
  }

  onModeChange(event) {
    this.sync(event.detail?.mode);
  }

  sync(mode) {
    const currentMode = mode || this.getStoredMode();
    const options = this.querySelectorAll('[data-price-mode-option]');

    options.forEach((option) => {
      const optionMode = option.getAttribute('data-price-mode-option');
      const isActive = optionMode === currentMode;
          
      option.classList.toggle('is-active', isActive);
    });
  }
}

if (!customElements.get('price-mode-switcher')) {
  customElements.define('price-mode-switcher', PriceModeSwitcher);
}
}